
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  useContext,
  useMeta,
  useRoute,
  useRouter,
  watch,
} from '@nuxtjs/composition-api';
import { useAlternateLinks } from '@/composables';

export default defineComponent({
  setup() {
    const route = useRoute();
    const router = useRouter();

    const {
      $axios,
      i18n,
      $api: { shopsService, countriesService },
    } = useContext();
    const { alternateLinks } = useAlternateLinks();

    const countryModal = ref(null);
    const shops = ref([]);
    const totalPagesCount = ref(null);
    const loading = ref(false);
    const countries = ref([]);
    const currentPage = computed(() => route.value.query.page);
    const notFound = ref(false);
    const currentCountry = ref(null);
    const countrySearch = ref('');
    const supportModal = ref(null);

    const filteredCountries = computed(() => {
      return countries.value.filter((country) =>
        countrySearch.value
          ? country.name.includes(countrySearch.value)
          : countries,
      );
    });

    const checkUserCountry = async () => {
      try {
        const response = await $axios.get(
          `https://pro.ip-api.com/json/?key=KzQdAMadVLQOM2c&lang=${i18n.locale}`,
        );
        currentCountry.value = countries.value.find(
          (c) => c.iso2 === response.data.countryCode,
        );
        if (!currentCountry.value) {
          currentCountry.value = {
            name: response.data.country,
            iso2: response.data.countryCode,
          };
          notFound.value = true;
        }
      } catch (error) {}
    };

    const getCountriesWithShops = async () => {
      try {
        const { data: shopsData } = await shopsService.getShopsCountriesIds();
        const { data: countriesData } =
          await countriesService.getCountriesByIds({
            country_id: shopsData.map((s) => s.id),
            lang: i18n.locale,
            limit: 1000,
          });
        countries.value = countriesData;
      } catch (error) {}
    };

    const fetchShops = async () => {
      if (notFound.value === true) return;
      loading.value = true;
      const { data, meta } = await shopsService.getAllShops({
        page: currentPage.value,
        limit: 16,
        search: `addresses.country_id:${currentCountry.value.id}`,
      });
      shops.value = data.map((shop) => {
        return {
          id: shop.id,
          name: shop.name,
          image: shop.image,
          url: shop.addresses && shop.addresses[0].url,
        };
      });
      totalPagesCount.value = meta.last_page;
      loading.value = false;
    };

    watch(currentPage, () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      fetchShops();
    });

    watch(currentCountry, (newValue, oldValue) => {
      if (!oldValue || newValue.id === oldValue.id) return;
      router.push({
        query: {
          page: undefined,
        },
      });
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      fetchShops();
    });

    onMounted(async () => {
      await getCountriesWithShops();
      await checkUserCountry();
      await fetchShops();
    });

    useMeta({
      title: `${i18n.t('where_to_buy')} Canyon`,
      meta: [
        {
          property: 'og:title',
          content: `${i18n.t('where_to_buy')} Canyon`,
        },
      ],
      link: alternateLinks.value,
    });

    const selectCountry = (country) => {
      notFound.value = false;
      currentCountry.value = country;
      countryModal.value.close();
    };

    return {
      countryModal,
      shops,
      currentCountry,
      selectCountry,
      countrySearch,
      filteredCountries,
      currentPage,
      totalPagesCount,
      loading,
      notFound,
      supportModal,
    };
  },
  head: {},
});
